import { Easy69_v1 } from "../frfr-easy69-utils";
import { js_utils } from "../frfr-js-utils";
import { _zzyourmap_LAYER_KEY_PREFIX, _zzyourmap_LAYER_TITLE_ALWAYSSHOW, _zzyourmap_lib_layer_titles_default } from "./zz-yourmap-data-keys-and-values-lib";
import { _zzyourmap_img_url_full_from_parts } from "./zz-yourmap-image-utils";
import { _zzyourmap_extract_smestaj_map_marker_item_props } from "./zz-yourmap-map-utils";


// MAP/MARKER/LAGEND LAYERS UTILS


//
export const _zzyourmap_fix_layer_title = (layer_title) => {
  if (Easy69_v1.is_string_not_empty(layer_title)) {
    // --- prepare layer title
    // STEP) Convert to lowercase and trim
    let fixed_layer_title = layer_title.toLowerCase().trim();
    // STEP) Replace 2 or more consecutive spaces with a single space
    fixed_layer_title = fixed_layer_title.replace(/\s{2,}/g, ' ');
    if (Easy69_v1.is_string_not_empty(fixed_layer_title)) {
      // valid and fixed layer title
      return fixed_layer_title;
    } else {
      return false; // invalid
    }
  } else {
    return false; // invalid
  }
};


//
export const _zzyourmap_convert_layer_title_to_layer_key = (layer_title) => {
  let fixed_layer_title = _zzyourmap_fix_layer_title(layer_title);
  if (Easy69_v1.is_string_not_empty(fixed_layer_title)) {
    // --- prepare layer key to css firendly
    let layer_key = fixed_layer_title;

    // STEP) Map Serbian Latin specific characters to standard English alphabet
    const serbianLatinChars = {
      'đ': 'dj',
      'ž': 'z',
      'ć': 'c',
      'č': 'c',
      'š': 's'
    };
    layer_key = layer_key.replace(/[đžćčš]/g, match => serbianLatinChars[match]);

    // STEP) Replace spaces with hyphens
    layer_key = layer_key.replace(/\s+/g, '-');

    // STEP) Remove any characters that are not lowercase letters, numbers, hyphens, or underscores.
    // layer_key = layer_key.replace(/[^a-z0-9-_]/g, '');

    // STEP) Replace any characters that are not lowercase letters, numbers, hyphens, or underscores, with underscores.
    /*
    // [^...] means "match everything EXCEPT the characters inside the brackets"
    // a-z : lowercase letters
    // 0-9 : numbers
    // -   : hyphen
    // _   : underscore
    */
    layer_key = layer_key.replace(/[^a-z0-9-_]/g, '_');

    // STEP) Ad layer prefix 'layer_'
    layer_key = _zzyourmap_LAYER_KEY_PREFIX + layer_key; //

    // valid and fixed layer key
    return layer_key;
  } else {
    return false; // invalid
  }
};


//
export const _zzyourmap_extract_layer_titles_all = (entities1, entities2) => {
  let layer_titles_all = [..._zzyourmap_lib_layer_titles_default]; // TODO
  let markerable_entities = entities1;
  if (Array.isArray(entities2)) {
    markerable_entities = [...entities1, ...entities2];
  }
  markerable_entities.forEach(item => {
    const marker_single = _zzyourmap_extract_smestaj_map_marker_item_props(item);
    if (marker_single) {
      if (typeof marker_single.layer_title === 'string' && marker_single.layer_title !== _zzyourmap_LAYER_TITLE_ALWAYSSHOW) {
        if (layer_titles_all.includes(marker_single.layer_title)) {
          // already included
        } else {
          layer_titles_all.push(marker_single.layer_title);
        }
      }
    }
  });
  console.log('layer_titles_all', layer_titles_all);
  return layer_titles_all;
};

